import React from "react";
import {
  Calendar,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuSelectItem,
  DropdownMenuSelectSubTrigger,
  DropdownMenuSelectTrigger,
  DropdownMenuSub,
  DropdownMenuSubContent,
  Label,
} from "@jem-open/jem-ui";
import moment from "moment";
import { Period, PERIOD_LABELS, PickerDateRange } from "../services/helpers";

interface PeriodSelectorProps {
  period: Period;
  customDateRange: PickerDateRange | undefined;
  onPresetChange: (value: string) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onRangeSelect: (range: any) => void;
}

const formatCustomRangeLabel = (range: PickerDateRange): string => {
  const from = moment(range.from).format("D MMM");
  const to = range.to ? moment(range.to).format("D MMM") : null;
  return to ? `${from} – ${to}` : from;
};

const PeriodSelector: React.FC<PeriodSelectorProps> = ({
  period,
  customDateRange,
  onPresetChange,
  onRangeSelect,
}) => {
  const triggerLabel =
    period === "custom" && customDateRange?.from
      ? formatCustomRangeLabel(customDateRange)
      : PERIOD_LABELS[period];

  return (
    <div className="flex flex-col gap-xxs">
      <Label className="text-xs text-greyscale-text-caption">Period</Label>
      <DropdownMenu>
        <DropdownMenuSelectTrigger className="min-w-[180px]">
          {triggerLabel}
        </DropdownMenuSelectTrigger>
        <DropdownMenuContent align="start" className="min-w-[180px]">
          <DropdownMenuRadioGroup
            value={period !== "custom" ? period : ""}
            onValueChange={onPresetChange}
          >
            <DropdownMenuSelectItem value="today">Today</DropdownMenuSelectItem>
            <DropdownMenuSelectItem value="week">This Week</DropdownMenuSelectItem>
            <DropdownMenuSelectItem value="month">This Month</DropdownMenuSelectItem>
          </DropdownMenuRadioGroup>
          <DropdownMenuSub>
            <DropdownMenuSelectSubTrigger active={period === "custom"}>
              Custom Range
            </DropdownMenuSelectSubTrigger>
            <DropdownMenuSubContent className="p-0">
              <Calendar
                mode="range"
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                selected={customDateRange as any}
                onSelect={onRangeSelect}
                numberOfMonths={2}
              />
            </DropdownMenuSubContent>
          </DropdownMenuSub>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default PeriodSelector;
